<template>
    <!-- Lang switcher -->
    <div class="lang-switcher tw-flex tw-justify-end tw-text-left tw-mb-20 md:tw-mb-0">

        <div class="tw-relative">
            <button
                type="button"
                aria-haspopup="true"
                aria-expanded="true"
                class="tw-flex tw-justify-center tw-items-center focus:tw-outline-none tw-ml-auto"
                @click.prevent="$store.state.langDropdown = !$store.state.langDropdown"
            >
                <img src="~@/assets/img/flags/en.svg" alt="Country Flag" class="tw-h-8 tw-w-8 tw-block" v-if="$i18n.locale == 'en'">
                <img src="~@/assets/img/flags/fr.svg" alt="Country Flag" class="tw-h-8 tw-w-8 tw-block" v-if="$i18n.locale == 'fr'">
                <img src="~@/assets/img/flags/pt.svg" alt="Country Flag" class="tw-h-8 tw-w-8 tw-block" v-if="$i18n.locale == 'pt'">
                <img src="~@/assets/img/flags/de.svg" alt="Country Flag" class="tw-h-8 tw-w-8 tw-block" v-if="$i18n.locale == 'de'">
            </button>
            <div
                class="tw-origin-top-right tw-absolute tw-shadow-lg tw-transition tw-ease-out tw-duration-100 tw-opacity-100 tw-scale-100"
                v-show="$store.state.langDropdown"
            >
                <div class="tw-bg-white tw-shadow-xs lang-dropdown">
                    <div role="menu" aria-orientation="vertical" aria-labelledby="options-menu" class="tw-py-1 tw-mt-2">
                        <router-link
                            to="/en"
                            class="tw-flex tw-w-40 tw-p-2 tw-items-center tw-uppercase tw-text-xs tw-text-black hover:tw-text-pink-600 hover:tw-underline tw-transition-all tw-duration-150"
                            v-if="$i18n.locale != 'en'"
                        >
                            <img src="~@/assets/img/flags/en.svg" alt="" class="tw-w-6 tw-h-6 tw-block tw-mr-3" @click="changeLang('en')">
                            <!--<span> English</span>-->
                        </router-link>
                        <router-link
                            to="/de"
                            class="tw-flex tw-w-40 tw-p-2 tw-items-center tw-uppercase tw-text-xs tw-text-black hover:tw-text-pink-600 hover:tw-underline tw-transition-all tw-duration-150"
                            v-if="$i18n.locale != 'de'"
                        >
                            <img src="~@/assets/img/flags/de.svg" alt="" class="tw-w-6 tw-h-6 tw-block tw-mr-3" @click="changeLang('de')">
                            <!--<span> Germany</span>-->
                        </router-link>
                        <router-link
                            to="/fr"
                            class="tw-flex tw-w-40 tw-p-2 tw-items-center tw-uppercase tw-text-xs tw-text-black hover:tw-text-pink-600 hover:tw-underline tw-transition-all tw-duration-150"
                            v-if="$i18n.locale != 'fr'"
                        >
                            <img src="~@/assets/img/flags/fr.svg" alt="" class="tw-w-6 tw-h-6 tw-block tw-mr-3" @click="changeLang('fr')">
                            <!--<span> France</span>-->
                        </router-link>
                        <router-link
                            to="/pt"
                            class="tw-flex tw-w-40 tw-p-2 tw-items-center tw-uppercase tw-text-xs tw-text-black hover:tw-text-pink-600 hover:tw-underline tw-transition-all tw-duration-150"
                            v-if="$i18n.locale != 'pt'"
                        >
                            <img src="~@/assets/img/flags/pt.svg" alt="" class="tw-w-6 tw-h-6 tw-block tw-mr-3" @click="changeLang('pt')">
                            <!--<span> Portugal</span>-->
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--/Lang switcher -->
</template>

<script>
export default {
    name: 'LanguageSwitcher',
    methods: {
        changeLang(lang) {
            window.location.href = `${window.location.origin}/${lang}`;
        },
    },
};
</script>
